import {useMutation, useQueryClient} from "@tanstack/react-query";
import {message} from "antd";
import {useClientV2} from "../../../../utils/hooks";
import {GET_STORE_SUBSCRIPTION_RQ_KEY} from "../constants";
import {invalidateSubscriptionListQueries} from "../invalidate-subscription-lists";

export type DeleteSubscriptionApiResponse = {
  status: boolean;
  message: string;
  statusCode?: number;
  data: Record<string, unknown>;
};

function formatError(error: unknown) {
  if (error && typeof error === "object" && "message" in error) {
    return String((error as {message: unknown}).message);
  }
  return "Could not delete subscription.";
}

export const useDeleteSubscriptionApi = () => {
  const queryClient = useQueryClient();
  const client = useClientV2();

  return useMutation({
    mutationFn: async (subscriptionId: number) => {
      return client(`subscriptions/${subscriptionId}`, {
        method: "DELETE",
      }) as Promise<DeleteSubscriptionApiResponse>;
    },
    onError: (error: unknown) => {
      message.error(formatError(error));
    },
    onSettled: (_, __, subscriptionId) => {
      queryClient.invalidateQueries({
        queryKey: [GET_STORE_SUBSCRIPTION_RQ_KEY, String(subscriptionId)],
      });
      invalidateSubscriptionListQueries(queryClient);
    },
  });
};
